import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import { Aggregate } from "@features/settings/types";
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useCallback, useMemo } from 'react';
import { RIOT_BLUE } from 'theme';

type Props = {
  initial: Aggregate;
  onChange: (a: Aggregate) => void;
}

const ChartAggregation = ({ initial, onChange }: Props) => {
  const userTenant = useAppSelector((state: RootState) => state.userTenant);
  const tenant = useAppSelector((state: RootState) => state.tenant);

  const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);
  const themeColor = useMemo(() => currentTenant?.builder_color || RIOT_BLUE, [currentTenant?.builder_color]);

  const handleChange = useCallback((e: SelectChangeEvent<Aggregate>) => {
    onChange(e.target.value as Aggregate);
  }, [onChange]);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <Select
        value={initial}
        onChange={handleChange}
        sx={{
          '&:focus': {
            border: `1px solid ${themeColor}`,
          }
        }}
      >
        <MenuItem value={Aggregate.none}>All values</MenuItem>
        <MenuItem value={Aggregate.avg}>Average values</MenuItem>
        <MenuItem value={Aggregate.max}>Biggest values</MenuItem>
        <MenuItem value={Aggregate.min}>Smallest values</MenuItem>
        <MenuItem value={Aggregate.sum}>Sum of all values</MenuItem>
      </Select>
    </FormControl>
  );
}

export default ChartAggregation;